module.exports = __webpack_public_path__ + "static/InternalMedicine-d71a38ef0bbe223ff344ead3bfad68e6.png";